"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SkeletonBase = _interopRequireDefault(require("./SkeletonBase"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var getSize = function getSize(value) {
  return isNumber(value) ? value + "px" : value;
};

var SkeletonLoad = (0, _styledComponents.default)(_SkeletonBase.default).withConfig({
  displayName: "SkeletonLoadWrapper__SkeletonLoad",
  componentId: "sc-16p4ogw-0"
})(_templateObject(), function (_ref) {
  var height = _ref.height;
  return getSize(height);
}, function (_ref2) {
  var width = _ref2.width;
  return getSize(width);
});

var SkeletonLoadWrapper = function SkeletonLoadWrapper(_ref3) {
  var isLoading = _ref3.isLoading,
      children = _ref3.children,
      widths = _ref3.widths,
      heights = _ref3.heights,
      style = _ref3.style,
      className = _ref3.className,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["isLoading", "children", "widths", "heights", "style", "className"]);

  if (isLoading) {
    return _react.default.createElement("div", {
      style: style,
      className: className
    }, widths.map(function (width, index) {
      return _react.default.createElement(SkeletonLoad, (0, _extends2.default)({
        key: index,
        className: index ? 'm-top-1' : null,
        height: heights[index],
        width: width,
        use: "on-shade"
      }, rest));
    }));
  }

  return children;
};

SkeletonLoadWrapper.propTypes = {
  children: _propTypes.default.node,
  isLoading: _propTypes.default.bool,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  style: _propTypes.default.object,
  className: _propTypes.default.string
};
SkeletonLoadWrapper.defaultProps = {
  isLoading: false,
  widths: ['100%'],
  heights: ['0.75em'],
  style: {}
};
var _default = SkeletonLoadWrapper;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/SkeletonLoadWrapper.js
// module id = 96
// module chunks = 5 6